import { render } from "./BaseEditorBtn.vue?vue&type=template&id=7b0c5f86"
import script from "./BaseEditorBtn.vue?vue&type=script&lang=js"
export * from "./BaseEditorBtn.vue?vue&type=script&lang=js"

import "./BaseEditorBtn.vue?vue&type=style&index=0&id=7b0c5f86&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__